/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Определяет поведение зависимости квеста от родительского.
 * @export
 * @enum {string}
 */
export enum FxIdDomainCrossPlayQuestDependencyType {
    HardLock = 0,
    ChainedProgress = 1,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainCrossPlayQuestDependencyType(value: any): boolean {
    for (const key in FxIdDomainCrossPlayQuestDependencyType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainCrossPlayQuestDependencyType, key)) {
            if (FxIdDomainCrossPlayQuestDependencyType[key as keyof typeof FxIdDomainCrossPlayQuestDependencyType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainCrossPlayQuestDependencyTypeFromJSON(json: any): FxIdDomainCrossPlayQuestDependencyType {
    return FxIdDomainCrossPlayQuestDependencyTypeFromJSONTyped(json, false);
}

export function FxIdDomainCrossPlayQuestDependencyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainCrossPlayQuestDependencyType {
    return json as FxIdDomainCrossPlayQuestDependencyType;
}

export function FxIdDomainCrossPlayQuestDependencyTypeToJSON(value?: FxIdDomainCrossPlayQuestDependencyType | null): any {
    return value as any;
}

export function FxIdDomainCrossPlayQuestDependencyTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainCrossPlayQuestDependencyType {
    return value as FxIdDomainCrossPlayQuestDependencyType;
}

